import React from 'react';
import PropTypes from 'prop-types';
import {Marker, Popup, TileLayer} from 'react-leaflet';
import {Box, Heading, Paper} from '@tenancy.nz/design-system';
import StyledMapContainer from './Map.styled';
import mapMarkerIcon from '../utils/icons/mapMarkerIcon';
import 'leaflet/dist/leaflet.css';

function Map({
  latitude = undefined,
  longitude = undefined,
  popupContent = undefined,
  title = undefined,
  sx = {},
}) {
  if (!longitude && !latitude) {
    return null;
  }

  const position = [latitude, longitude];

  return (
    <Box sx={sx}>
      {title && (
        <Box mb="16px">
          <Heading as="h4">{title}</Heading>
        </Box>
      )}
      <Paper>
        <Box sx={{padding: {xs: '8px', md: '16px'}}}>
          <StyledMapContainer
            center={position}
            zoom={16}
            scrollWheelZoom={false}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={position} icon={mapMarkerIcon}>
              {popupContent && <Popup>{popupContent}</Popup>}
            </Marker>
          </StyledMapContainer>
        </Box>
      </Paper>
    </Box>
  );
}

Map.propTypes = {
  latitude: PropTypes.string,
  longitude: PropTypes.string,
  popupContent: PropTypes.node,
  title: PropTypes.string,
  sx: PropTypes.object,
};

export default Map;
